// section -> menu -> sub menu -> item

export const hamBurgerSections = [
  {
    label: 'General',
    menu: [
      {
        id: 'product-categories',
        label: 'Product Categories',
        icon: 'categories',
        subMenu: [],
      },
      {
        id: 'brands',
        label: 'Brands',
        icon: 'brand',
        subMenu: [
          {
            id: 'singer',
            label: 'Singer',
            image: '/images/singer-logo-red.png',
          },
          {
            id: 'beko',
            label: 'Beko',
            image: '/images/beko-logo-blue.png',
          },
          {
            id: 'hitachi',
            label: 'Hitachi',
            image: '/images/hitachi-logo-black.png',
          },
          {
            id: 'others',
            label: 'Others',
            items: [
              {
                label: 'Blueair',
                id: 'blueair',
              },
              {
                label: 'Dell',
                id: 'dell',
              },
              {
                label: 'Galanz',
                id: 'galanz',
              },
              {
                label: 'Haier',
                id: 'haier',
              },
              {
                label: 'Havells',
                id: 'havells',
              },
              {
                label: 'Hisense',
                id: 'hisense',
              },
              {
                label: 'HP',
                id: 'hp',
              },
              {
                label: 'Lenovo',
                id: 'lenovo',
              },
              {
                label: 'Panasonic',
                id: 'panasonic',
              },
              {
                label: 'Phillips',
                id: 'phillips',
              },
              {
                label: 'Phillips and Havells',
                id: 'phillipsandhavells',
              },
              {
                label: 'Preethi',
                id: 'preethi',
              },
              {
                label: 'Samsung',
                id: 'samsung',
              },
              {
                label: 'Skyworth',
                id: 'skyworth',
              },
              {
                label: 'Symphony',
                id: 'symphony',
              },
              {
                label: 'Toshiba',
                id: 'toshiba',
              },
              {
                label: 'Unilever',
                id: 'unilever',
              },
              {
                label: 'V-Guard',
                id: 'vguard',
              },
              {
                label: 'Videocon',
                id: 'videocon',
              },
              {
                label: 'Vision',
                id: 'vision',
              },
              {
                label: 'Whirlpool',
                id: 'whirlpool',
              },
            ],
          },
        ],
      },
      {
        label: 'Campaigns',
        icon: 'gift',
        url: '/campaign', // campaign url will add later
      },
    ],
  },
  {
    id: 'my-singer',
    label: 'My Singer',
    menu: [
      {
        id: 'my-orders',
        label: 'My Orders',
        icon: 'cart',
        subMenu: [
          {
            id: 'on-going',
            label: 'Ongoing',
            icon: 'past-order',
            url: '/my-orders?tab=ongoing',
          },
          {
            id: 'past',
            label: 'Completed',
            icon: 'ongoing-order',
            url: '/my-orders?tab=past',
          },
        ],
      },
      {
        id: 'my-account',
        label: 'My Account',
        icon: 'user',
        subMenu: [
          {
            id: 'wishlist',
            label: 'Wishlist',
            icon: 'heart',
            url: '/wishlist',
          },
          // { id: 'past', label: 'Completed', icon: 'brand', url: '#' },
          {
            id: 'past',
            label: 'Completed',
            icon: 'ongoing-order',
            url: '/my-orders?tab=past',
          },
          {
            id: 'address',
            label: 'Address',
            icon: 'edit-location',
            url: '/address',
          },
        ],
      },
    ],
  },
  {
    label: 'Support',
    isStoreLocator: true,
    menu: [
      {
        id: 'faq',
        label: 'FAQ',
        icon: 'question-mark',
        url: '/faq',
      },
      // Will be done after MVP
      {
        id: 'emi-options',
        label: 'EMI Options',
        icon: 'calender',
        url: '/emi-options',
      },
      {
        id: 'help-request',
        label: 'Help Request',
        icon: 'help-request',
        url: '/help-request',
      },
    ],
  },
  {
    label: 'Language',
    isLanguageOption: true,
    menu: [
      {
        id: 'en',
        name: 'en',
        icon: '/images/flag-usa.png',
      },
      {
        id: 'bn',
        name: 'bn',
        icon: '/images/flag-bd.png',
      },
    ],
  },
];

export const otherhamBurgerSections = [];
